export default __webpack_public_path__ + "static/media/Logo-Effe-Bianco.9f7bcd68.svg";